// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import WelcomeModal from './components/WelcomeModal';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerificationSentPage from './pages/VerificationSentPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import PublishItemPage from './pages/PublishItemPage';
import MyProductsPage from './pages/MyProductsPage';
import ItemDetailPage from './pages/ItemDetailPage';
import EditItemPage from './pages/EditItemPage';
import ProfilePage from './pages/ProfilePage';
import UserProfilePage from './pages/UserProfilePage';
import AdminPage from './pages/AdminPage';
import MisTransaccionesPage from './pages/MisTransaccionesPage';
import RequestPasswordResetPage from './pages/RequestPasswordResetPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import MisFavoritosPage from './pages/MisFavoritosPage';
import MensajesPage from './pages/MensajesPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <FavoritesProvider>
          <div className="d-flex flex-column min-vh-100">
            <Navbar />
            <WelcomeModal />
            <main className="container mb-4 flex-grow-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/items/:id" element={<ItemDetailPage />} />
                <Route path="/perfil/:id" element={<UserProfilePage />} />
                <Route path="/verificacion-enviada" element={<VerificationSentPage />} />
                <Route path="/verificar-email/:token" element={<VerifyEmailPage />} />
                <Route path="/publicar" element={<ProtectedRoute><PublishItemPage /></ProtectedRoute>} />
                <Route path="/mis-publicaciones" element={<ProtectedRoute><MyProductsPage /></ProtectedRoute>} />
                <Route path="/items/:id/editar" element={<ProtectedRoute><EditItemPage /></ProtectedRoute>} />
                <Route path="/editar-perfil" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly={true}><AdminPage /></ProtectedRoute>} />
                <Route path="/mis-favoritos" element={<ProtectedRoute><MisFavoritosPage /></ProtectedRoute>} />
                <Route path="/mis-transacciones" element={<ProtectedRoute><MisTransaccionesPage /></ProtectedRoute>} />
                <Route path="/mensajes" element={<ProtectedRoute><MensajesPage /></ProtectedRoute>} />
                <Route path="/solicitar-reseteo" element={<RequestPasswordResetPage />} />
                <Route path="/resetear-password/:token" element={<ResetPasswordPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </FavoritesProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
